import ApiService from "../../api.service";
import appConfig from "@/app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SurveyTemplateService = {
  async saveSurveyTemplate(payload) {
    var url = "api/Save_SurveyTemplate";

    return await ApiService.post(url, payload, "String");
  },

  async getByRecordId(recordId) {
    const requestScreenData = {
      url: "api/SurveyTemplate",
      top: "1",
      filter: `RecordId eq ${recordId}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getQuestionsBySurveyTemplateId(code) {
    const requestScreenData = {
      url: "api/SurveyTemplateQuestion",
      filter: `SurveyTemplateRecordID eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getCustomersBySurveyTemplateId(code) {
    const requestScreenData = {
      url: "api/SurveyTemplateCustomer",
      filter: `SurveyTemplateRecordID eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async cancelSurveyTemplate(payload) {
    var url = `api/SurveyTemplate/${payload.RecordId}/Cancel`;

    return await ApiService.post(url, payload, "String");
  },
};

export { SurveyTemplateService };
